import {
  isRequired,
  matchesField,
  hasLengthGreaterThan,
  combineValidators,
  composeValidators,
  createValidator
} from 'revalidate';

const passwordRequired = isRequired({ message: 'passwordCannotBeBlank' });
const isStrongEnough = createValidator(
  message => value => {
    if (value === 'password' || value === 'testing') return message;
  },
  () => 'chooseStrongerPassword'
);
const isLongEnough = hasLengthGreaterThan(7)({ message: 'passwordTooShort' });
const passwordsMatch = matchesField('password')({ message: 'passwordsDoNotMatch' });

export const validate = combineValidators({
  password: composeValidators(passwordRequired, isStrongEnough, isLongEnough)('password'),
  confirmPassword: passwordsMatch
});
